import {
  DisconnectOutlined,
  HddOutlined,
  ProfileOutlined,
  WifiOutlined
} from '@ant-design/icons'
import { Card, Col, Empty, Row, Space, Statistic } from 'antd'
import React from 'react'
import { DashboardProps } from './interface'
import styles from './index.css'
import { getFormatMessage } from '@/utils/utils'

export const Dashboard: React.FC<DashboardProps> = (props: DashboardProps) => {
  const formatMessage = getFormatMessage()

  return (
    <div>
      <Row gutter={24}>
        <Col span={12}>
          <Card
            title={formatMessage({ id: 'app.dashboard.mqttServer' })}
            style={{ minHeight: 200 }}
          >
            {props.server && (
              <div>
                <Space>
                  <HddOutlined />
                  <span>{props.server.name}</span>
                </Space>
                <div className={styles['conn']}>
                  <Statistic
                    value={props.server.url}
                    suffix={
                      <DisconnectOutlined
                        style={{
                          fontSize: 12,
                          verticalAlign: 'middle',
                          color: '#1afa29'
                        }}
                      />
                    }
                  />
                </div>
              </div>
            )}
            {!props.server && <Empty description='未配置服务器地址' />}
          </Card>
        </Col>
        <Col span={12}>
          <Card title={formatMessage({ id: 'app.dashboard.summary' })}>
            <Card.Grid
              hoverable={false}
              style={{ width: '50%', textAlign: 'center', minHeight: 200 }}
            >
              <Statistic
                title={
                  <div className={styles['statistic-title']}>
                    <ProfileOutlined />
                    <span>
                      {formatMessage({ id: 'app.dashboard.summary.total' })}
                    </span>
                  </div>
                }
                value={props.summary?.boxTotalCount}
              />
              {/* <Empty description='未连接' /> */}
            </Card.Grid>
            <Card.Grid
              hoverable={false}
              style={{ width: '50%', textAlign: 'center', minHeight: 200 }}
            >
              <Statistic
                title={
                  <div className={styles['statistic-title']}>
                    <WifiOutlined />
                    <span>
                      {formatMessage({ id: 'app.dashboard.summary.online' })}
                    </span>
                  </div>
                }
                value={props.summary?.boxOnlineCount}
              />
              {/* <Empty description='未连接' /> */}
            </Card.Grid>
          </Card>
        </Col>
      </Row>
    </div>
  )
}
